import React from "react";
import { RouterProvider, createBrowserRouter } from "react-router-dom";

import LayoutMain from "./assets/component/layout";
import AuthLayoutMain from "./assets/component/layout/auth-layout";
import uris from "./config/uris";
import ResetPassword from "./pages/auth/password-reset";
import CompanyResearchMain from "./pages/company-research";
import CompanyHistory from "./pages/company-research/history";
import CompanyInsights from "./pages/company-research/insights";
import CompanySourceList from "./pages/company-research/source-list";
import CustomResearchMain from "./pages/custom-research";
import CustomHistory from "./pages/custom-research/history";
import CustomInsights from "./pages/custom-research/insights";
import CustomSourceList from "./pages/custom-research/source-list";
import Frameworks from "./pages/esg-playbook/frameworks";
import Regulations from "./pages/esg-playbook/regulations";
import Screeners from "./pages/esg-playbook/screeners";
import InvestorResearchMain from "./pages/investor-research";
import InvestorHistory from "./pages/investor-research/history";
import InvestorInsights from "./pages/investor-research/insights";
import InvestorSourceList from "./pages/investor-research/source-list";
import Login from "./pages/login/index";
import OrganizationSetting from "./pages/org-settings";
import PrivateResearchMain from "./pages/private-research";
import RealEstateResearchMain from "./pages/real-estate-research";
import RealEstateHistory from "./pages/real-estate-research/history";
import RealEstateInsights from "./pages/real-estate-research/insights";
import RealEstateSourceList from "./pages/real-estate-research/source-list";
import SignUp from "./pages/auth/sign-up";
import SupportMain from "./pages/support";
import StripeCheckout from "./pages/auth/stripe-checkout/checkout";
import PaymentSuccess from "./pages/auth/stripe-checkout/payment-success";
import PaymentCancel from "./pages/auth/stripe-checkout/payment-cancel";
import Page404 from "./pages/errors/404";
import ManagePlaybook from "./pages/custom-playbook/manage-playbook";
import ControResearchMain from "./pages/contro-research";
import ViewPlaybook from "./pages/custom-playbook/view-playbook";
// import EditPlaybook from "./pages/custom-playbook/manage-playbook/edit-playbook";
import UploadEntities from "./pages/entities/upload-entity";
import ManageEntity from "./pages/entities/manage-entity";
import FundResearchMain from "./pages/fund-research";
import FundHistory from "./pages/fund-research/history";
import CustomModelEvaluation from "./pages/labs/model-evaluation";
import SettingsMain from "./pages/settings";
import PromptEvaluation from "./pages/labs/prompt-evaluation";
import PromptHistory from "./pages/labs/history";
import ControListMain from "./pages/contro-research/contro-list";
import ReviewEntities from "./pages/gemini/review-entities";
import OutputReview from "./pages/gemini/output-review";
import EntityList from "./pages/gemini/entity-list";
import MetricsView from "./pages/gemini/view-metrics";
import CreateBatch from "./pages/playbook-batch/create-batch";
import ManageBatch from "./pages/playbook-batch/manage-batch";
import GeminiPromptEvaluation from "./pages/gemini/prompt-evaluation";
import Portfolio from "./pages/preferences/portfolio";
import Dashboard from "./pages/dashboard";
import ChunkEvaluation from "./pages/labs/chunk-evaluation";
import DataExtractor from "./pages/data-extractor";
import FinanceEmissions from "./pages/finance-emissions";
import PortfolioScreening from "./pages/portfolio-screening";
import CustomPlaybook from "./pages/esg-playbook/custom-playbook";

function App() {

  // Alphabet-wise
  const router = createBrowserRouter([
    {
      path: uris.chunkEvaluation,
      element: (<LayoutMain Component={ChunkEvaluation} showSidebar />),
    },
    {
      path: uris.companyDisclosureDetails,
      element: (<LayoutMain Component={CompanySourceList} showSidebar />),
    },
    {
      path: uris.companyHistory,
      element: (<LayoutMain Component={CompanyHistory} showSidebar />),
    },
    {
      path: uris.companyInsights,
      element: (<LayoutMain Component={CompanyInsights} showSidebar />),
    },
    {
      path: uris.companyResearch,
      element: (<LayoutMain Component={CompanyResearchMain} showSidebar />),
    },
    {
      path: uris.controResearch,
      element: (<LayoutMain Component={ControListMain} showSidebar />),
    },
    {
      path: uris.createBatch,
      element: (<LayoutMain Component={CreateBatch} showSidebar />)
    },
    {
      path: uris.customDisclosureDetails,
      element: (<LayoutMain Component={CustomSourceList} showSidebar />),
    },
    {
      path: uris.customHistory,
      element: (<LayoutMain Component={CustomHistory} showSidebar />),
    },
    {
      path: uris.customInsights,
      element: (<LayoutMain Component={CustomInsights} showSidebar />),
    },
    {
      path: uris.customPlaybook,
      element: (<LayoutMain Component={CustomPlaybook} showSidebar />)
    },
    {
      path: uris.customResearch,
      element: (<LayoutMain Component={CustomResearchMain} showSidebar />),
    },
    // {
    //   path: uris.editPlaybook,
    //   element: (<LayoutMain Component={EditPlaybook} showSidebar />),
    // },
    {
      path: uris?.dashboard,
      element: (<LayoutMain Component={Dashboard} showSidebar />)
    },
    {
      path: uris.dataExtractor,
      element: (<LayoutMain Component={DataExtractor} showSidebar />),
    },
    {
      path: uris.financeEmissions,
      element: (<LayoutMain Component={FinanceEmissions} showSidebar />),
    },
    {
      path: uris.portfolioScreening,
      element: (<LayoutMain Component={PortfolioScreening} showSidebar />),
    },
    {
      path: uris.entityList,
      element: (<LayoutMain Component={EntityList} showSidebar />),
    },
    {
      path: uris.esgPlaybookFrameworks,
      element: (<LayoutMain Component={Frameworks} showSidebar />)
    },
    {
      path: uris.esgPlaybookRegulations,
      element: (<LayoutMain Component={Regulations} showSidebar />)
    },
    {
      path: uris.esgPlaybookScreeners,
      element: (<LayoutMain Component={Screeners} showSidebar />)
    },
    {
      path: uris.fundHistory,
      element: (<LayoutMain Component={FundHistory} showSidebar />)
    },
    {
      path: uris.fundResearch,
      element: (<LayoutMain Component={FundResearchMain} showSidebar />)
    },
    {
      path: uris.geminiPromptEvaluation,
      element: (<LayoutMain Component={GeminiPromptEvaluation} showSidebar />)
    },
    {
      path: uris.investorDisclosureDetails,
      element: (<LayoutMain Component={InvestorSourceList} showSidebar />),
    },
    {
      path: uris.investorHistory,
      element: (<LayoutMain Component={InvestorHistory} showSidebar />),
    },
    {
      path: uris.investorInsights,
      element: (<LayoutMain Component={InvestorInsights} showSidebar />),
    },
    {
      path: uris.investorResearch,
      element: (<LayoutMain Component={InvestorResearchMain} showSidebar />),
    },
    {
      path: uris.labsModelEvaluation,
      element: (<LayoutMain Component={CustomModelEvaluation} showSidebar />),
    },
    {
      path: uris.labsPromptEvaluation,
      element: (<LayoutMain Component={PromptEvaluation} showSidebar />),
    },
    {
      path: uris.labsHistory,
      element: (<LayoutMain Component={PromptHistory} showSidebar />),
    },
    {
      path: uris.manageEntity,
      element: (<LayoutMain Component={ManageEntity} showSidebar />),
    },
    {
      path: uris.managePlaybook,
      element: (<LayoutMain Component={ManagePlaybook} showSidebar />),
    },
    {
      path: uris.viewMetrics,
      element: (<LayoutMain Component={MetricsView} showSidebar />),
    },
    {
      path: uris.orgSettings,
      element: (<LayoutMain Component={OrganizationSetting} showSidebar />),
    },
    {
      path: uris.outputReview,
      element: (<LayoutMain Component={OutputReview} showSidebar />),
    },
    {
      path: uris.paymentCancel,
      element: <AuthLayoutMain Component={PaymentCancel} showSidebar />,
    },
    {
      path: uris.paymentSuccess,
      element: <AuthLayoutMain Component={PaymentSuccess} showSidebar />,
    },
    {
      path: uris.playbookBatch,
      element: (<LayoutMain Component={ManageBatch} showSidebar />)
    },
    {
      path: uris.portfolio,
      element: (<LayoutMain Component={Portfolio} showSidebar />)
    },
    {
      path: uris.privateResearch,
      element: <LayoutMain Component={PrivateResearchMain} showSidebar />,
    },
    {
      path: uris.reviewEntities,
      element: (<LayoutMain Component={ReviewEntities} showSidebar />),
    },
    {
      path: uris.login,
      element: (<AuthLayoutMain Component={Login} />),
    },
    {
      path: uris.realEstateDisclosureDetails,
      element: (<LayoutMain Component={RealEstateSourceList} showSidebar />),
    },
    {
      path: uris.realEstateHistory,
      element: (<LayoutMain Component={RealEstateHistory} showSidebar />),
    },
    {
      path: uris.realEstateInsights,
      element: (<LayoutMain Component={RealEstateInsights} showSidebar />),
    },
    {
      path: uris.realEstateResearch,
      element: (<LayoutMain Component={RealEstateResearchMain} showSidebar />),
    },
    {
      path: uris.resetPassword,
      element: (<AuthLayoutMain Component={ResetPassword} />),
    },
    {
      path: uris.register,
      element: (<AuthLayoutMain Component={SignUp} />),
    },
    {
      path: uris.settings,
      element: (<LayoutMain Component={SettingsMain} showSidebar />),
    },
    {
      path: uris.stripeCheckout,
      element: (<AuthLayoutMain Component={StripeCheckout} hideHeader />),
    },
    {
      path: uris.support,
      element: (<LayoutMain Component={SupportMain} showSidebar />),
    },
    {
      path: uris.uploadEntities,
      element: (<LayoutMain Component={UploadEntities} showSidebar />)
    },
    {
      path: uris.viewQuestions,
      element: (<LayoutMain Component={ViewPlaybook} showSidebar />),
    },
    {
      path: "*",
      element: (<AuthLayoutMain Component={Page404} />),
    },
  ]);

  return <RouterProvider router={router} />;
}

export default App;
